export const NO_DATA = 'No data' as const;
